import { createFileRoute } from "@tanstack/react-router";
import { getRegion } from "@/lib/seo/regions";
import { regionRoute } from "@/lib/seo/regionRoute";

const region = getRegion("norrland")!;

export const Route = createFileRoute("/filmproduktion-norrland")(regionRoute(region));
